import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  loginForm: FormGroup; // Initialize a FormGroup for the login form
  error: string = '';   // Initialize error message to an empty string
  hint: string = '';   // Initialize hint message to an empty string

  constructor(private authService: AuthService) {
     // Initialize the login form with email validation
    this.loginForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,        // Email field is required
        Validators.pattern(        // Validate email format using a regular expression
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ),
      ]),
    });
  }

  ngOnInit(): void {
    // Component initialization logic can be added here
  }
  onChange() {
    this.error = '';   // Clear the error message when input changes
  }
  get f() {
    return this.loginForm.controls;  // Create a shortcut to access form controls in the HTML template
  }
  onSubmit() {
    if (this.loginForm.valid) {    // If the form is valid
      this.authService.forgotPassword(this.loginForm.value).subscribe(
        (result: any) => {
          if (result.Response == 'Data Updated') {    // If the password reset was successful
            this.hint = 'Password reset link sent to email';
          } else {
            this.error = 'Invalid Email';  // If the email is invalid
          }
        },
        (error: any) => {
           // If there was an error during the password reset
          this.error = 'Invalid Email..Please try again.';
        }
      );
    } else {
      this.error = 'Please enter a valid email';   // If the form is invalid
    }
  }
}
